import CONFIG_COLUMN_TYPES from '@/components/view_root_components/base_level_table_module/enums/CONFIG_COLUMN_TYPES';
import get from 'lodash/get';

const DEFAULT_FORMATTER = (column, key) => get(column, key);
const MAP_FORMATTER = (v, key, typeFormatter) => {
    if (get(v, key) == undefined) return
    return typeFormatter(get(v, key) == "true")
}

export default {
    props: {
        columnMapping: { type: Function, default: (_column) => { 
            return {
              text: _column.readableName,
              value: _column.valueKey
            }
          }
        }
    },
    methods: {
        /******************
        * HELPERS
        ******************/
        _getMappedconfigurableColumns(columns) {
            return columns.map((_column) => {
                let columnMapping = this.columnMapping(_column)

                columnMapping = this._mapColumnDataTypeFormatter(_column, columnMapping);
                return columnMapping;
            })
        },

        _mapColumnDataTypeFormatter(_column, columnMapping) {
            const typeFormatter = CONFIG_COLUMN_TYPES[_column.type];
            if (typeFormatter != undefined) {
                columnMapping['presentWith'] = (i, v) => MAP_FORMATTER(v, _column.valueKey, typeFormatter);
            }
            else {
                columnMapping['presentWith'] = (i, v) => DEFAULT_FORMATTER(v, _column.valueKey);
            }
            return columnMapping;
        }
    }
}